
import { hollyMediaArray } from './hollyMedia'
import { frodoReviewerProfile, luigiReviewerProfile, gatsbyReviewerProfile } from './hollyReviewers'
import { frodoBio, hollyBio, luigiBio, gatsbyBio } from './hollyBios'
import { hollyDatingProfileHinge, hollyDatingProfileBumble, hollyDatingProfileTinder } from './hollyDatingProfiles'

export const hollyUser = {
  _id: 'hollyUserId',
  email: 'holly@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...frodoReviewerProfile },
    { ...luigiReviewerProfile },
    { ...gatsbyReviewerProfile }
  ],
  media: [ ...hollyMediaArray ],
  bio: { ...hollyBio },
  datingProfiles: [
    { ...hollyDatingProfileHinge },
    { ...hollyDatingProfileBumble },
    { ...hollyDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const frodoUser = {
  _id: 'frodoUserId',
  email: 'frodo@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...frodoBio },
  datingProfiles: [],
  reviewerProfile: { ...frodoReviewerProfile },
}

export const luigiUser = {
  _id: 'luigiUserId',
  email: 'luigi@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...luigiBio },
  datingProfiles: [],
  reviewerProfile: { ...luigiReviewerProfile },
}

export const gatsbyUser = {
  _id: 'gatsbyUserId',
  email: 'gatsby@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...gatsbyBio },
  datingProfiles: [],
  reviewerProfile: { ...gatsbyReviewerProfile },
}
